// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__RYf2M"};